import { createConsumer } from "@rails/actioncable"

let consumer = null

export const getCable = () => {
  if (!consumer) {
    consumer = createConsumer("/cable")
  }
  return consumer
}
